import React from 'react';
import classNames from 'classnames';
import { useTheme } from '../../../../../ThemeContext';

import styles from './FormFeedback.module.scss';

type Props = {
  visible?: boolean;
  children?: React.ReactNode;
  variant: 'info' | 'success' | 'warning' | 'error';
  className?: string;
};

const variantAriaMap = {
  info: 'polite',
  success: 'assertive',
  warning: 'polite',
  error: 'assertive',
} as const;

const FormFeedback: React.FC<Props> = ({ children, variant = 'error', visible = true, className: customClassName }: Props) => {
  const className = classNames(styles.formFeedback, customClassName, {
    [styles.error]: variant === 'error',
    [styles.warning]: variant === 'warning',
    [styles.success]: variant === 'success',
    [styles.info]: variant === 'info',
    hidden: !visible,
  });

  const ariaLive = variantAriaMap[variant];
  const { universalStyles } = useTheme();

  const textFieldStyle = {
    ...(variant === 'error' ? { ...universalStyles.errorBorder } : {}),
  };
  
  return (
    <div aria-live={ariaLive} className={className} style={textFieldStyle}>
      {children}
    </div>
  );
};

export default FormFeedback;
